<template>
  <div class="fyrfalt-scroll_wrapper" :style='cssVars'>
    <div class="fyrfalt-background" :class="{ clickable: clickable }">
      <SvgWrapper
        :region="null"
        :options="options"
        :innerHeight="height"
      />
    </div>
    <div class="fyrfalt-content">
      <ScrollStory v-for="(story, index) in stories" :key="index" :story="story" :innerHeight="height" />
    </div>
  </div>
  <div class="plus-article-story">
    <h3 class="md-heading">Tarkastele oman alueesi valtuutettuja</h3>
    <p class="md-paragraph">{{ labels.exploreScatter }}</p>
    <!-- <div class="filters">
      <select v-model="selectedRegion" class="yddviz-select">
        <option :value="null">{{ labels.selectRegion }}</option>
        <option v-for="region in regions" :value="region.id" :key="region.id">
          {{ region[`short_name_${lang}`] }}
        </option>
      </select>
      <p v-if="selectedRegion"><a @click.prevent="selectedRegion = null" class="reset-link">{{ labels.clear }}</a></p>
    </div> -->
    <v-select class='select' v-model='selectedRegion' :clearable='false' :options='selectOptions' @change='handleChange'>
      <template v-slot:no-options='{ searching }'>
        <template v-if='searching' class='no-options'>
          Ei tuloksia.
        </template>
      </template>
    </v-select>
  </div>
  <ScatterWrapper
    :region="selectedRegion"
    @update-region="selectedRegion = $event"
    :innerHeight="height"
  />
</template>

<script>
import scrollama from 'scrollama'
const scroller = scrollama();
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

import ScrollStory from './components/ScrollStory.vue'
import SvgWrapper from './components/SvgWrapper.vue'
import ScatterWrapper from './components/ScatterWrapper.vue'

import { stories, labels } from './data/texts.js'
import regions from './data/hva_meta.json'

export default {
  name: 'App',
  components: {
    vSelect,
    ScrollStory,
    SvgWrapper,
    ScatterWrapper
  },
  data() {
    return {
      stories,
      labels,
      selectedRegion: {label: 'Koko maa', value: null},
      selectOptions: [],
      selectedQuestion: null,
      clickable: false,
      options: {},
      regions,
      compareMode: 'parties',
      height: window.innerHeight,
    }
  },
  methods: {
    populateSelectOptions() {
      let selectOptionArray = [];
      let sortedData = regions;
      sortedData.sort((a,b) => a['short_name_fi'] > b['short_name_fi'] ? 1 : b['short_name_fi'] > a['short_name_fi'] ? -1 : 0);
      selectOptionArray.push({label: 'Koko maa', value: null});
      for (let i = 0; i < sortedData.length; i++) {
        selectOptionArray.push({label: sortedData[i]['short_name_fi'], value: sortedData[i].id });
      }
      this.selectOptions = selectOptionArray;
    },
    handleChange(value) {
      if (this.selectOptions.includes(value)) {
        this.selectedRegion = value;
      }
    },
    formatText(text, questionIndex) {
      if (text.includes('{question}')) {
        text = text.replace('{question}', `<strong>${this.questions[questionIndex][this.lang]}</strong>`);
      }
      return text;
    },
    setHeight () {
      this.height = window.innerHeight;
      console.log(window.innerHeight);
    },
  },
  computed: {
    /* Variables you want to pass to CSS */
    cssVars () {
      return {
        '--paddingTop': this.height * 0.9 + 'px',
        '--marginTop': this.height * -0.5 + 'px'
      }
    }
  },
  created() {
    this.populateSelectOptions();
    window.addEventListener('resize', this.setHeight);
  },
  mounted() {
    scroller
      .setup({
        step: '#app-2022-01-aluevaalit-kompassianalyysi .story-content',
        offset: 0.67,
        debug: false,
      })
      .onStepEnter(response => {
        this.options = this.stories[response.index].options;
        this.clickable = this.options.clickable ? this.options.clickable : false;
        // this.selectedRegion = {label: 'Valitse hyvinvointialue...', value: null};
      })
  },
  unmounted() {
    window.removeEventListener('resize', this.setHeight);
  },
}
</script>

<style lang="scss">
body {
  background-color: white;
  color: black;
}
#app-2022-01-aluevaalit-kompassianalyysi {
  max-width: 720px;
  margin: 0 auto;
  font-family: 'Open Sans', Arial, sans-serif;
  // padding: 0 16px;

  h2 {
    font-family: 'Yle', 'Open Sans', sans-serif;
    font-size: 18px;
    letter-spacing: 0px;
    line-height: 25.2px;
    font-weight: 900;
    margin-bottom: 16px;
    padding-top: 16px;
    @media (min-width: 768px) {
      font-size: 20px;
      line-height: 28px;
    }
  }

  h3 {
      font-size: 18px;
      font-weight: 600;
    }

  .plus-article-story {
    max-width: 680px;
    width: 100%;
    margin: 0 auto;
  }

  .select {
    max-width: 300px;
    margin: 5px 0 20px 0;
    padding: 3px 10px;
    border: none;
    font-family: 'Open Sans', sans-serif;
    font-size: 16px;
    font-weight: 400;
    box-shadow: 0 0 10px 2px rgba(0,0,0,.1);
  }
  .no-options {
    font-family: 'Open Sans', sans-serif;
    font-weight: 400;
  }
  .select .vs__dropdown-toggle {
    border: none;
  }
  .select .vs__dropdown-menu {
    max-height: 200px;
  }

  .plus-article-story > .md-heading {
    font-family: 'Yle', 'Open Sans', sans-serif;
    font-style: normal;
    font-size: 20px;
    font-weight: 900;
    line-height: 28px;
    text-align: left;
    margin: 0 0 24px 0;
    padding: 0;
    @media (max-width: 767px) {
      font-size: 18px;
      line-height: 25.2px;
      margin: 0 0 16px 0;
    }
  }

  .plus-article-story > .md-paragraph {
    font-family: "Open Sans", sans-serif;
    font-size: 16px;
    letter-spacing: 0px;
    line-height: 24px;
    font-weight: 400;
    margin: 0 0 24px 0;

    @media (min-width: 768px) {
      font-size: 18px;
      line-height: 27px;
    }
  }

  .plus-article-story p {
    color: rgb(19, 20, 21);
  }

  .fyrfalt-background {
    position: sticky;
    top: 50px;
    overflow: hidden;
    z-index: -1;

    &.clickable {
      z-index: 2;
    }
  }

  .fyrfalt-content {
    max-width: 700px;
    margin: 0 auto;
    // padding-top: var(--paddingTop);
    // margin-top: var(--marginTop);
    padding-top: 90vh;
    margin-top: -50vh;
  }

  .filters {
    max-width: 980px;
    margin: 0;
  }

  .reset-link {
    text-decoration: underline;
    cursor: pointer;
  }

  .radio-filters {
    border: none;
    padding: 0;
    margin: 1em 0;

    label {
      margin-right: .5em;
      white-space: nowrap;
    }
  }

  .yddviz-select {
    display: block;
    margin-bottom: .5em;
    border: 2px solid #333;
    border-radius: 6px;
    padding: 6px;
    width: 100%;
    font-size: 16px;
    line-height: 1.5;
    font-weight:bold;

    &:focus {
      outline: none;
      border: 2px dashed #333;
      background: #f5f5f5;
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.ydd-article {
  overflow: initial;
}
</style>